export default __webpack_public_path__ + "locales/cs/VersionHistory.json?hash=308002ce949dc3077b85952bd71274e0";